import React from "react";
import { Card } from "../../../shared/components/Card.jsx";
import { Badge } from "../../../shared/components/Badge.jsx";

/** "12 Sept, 03:40 pm" style timestamp for a stock movement. */
export function formatMovementTime(movement) {
  return movement.createdAt
    ? new Date(movement.createdAt).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit"
      })
    : "Just now";
}

export const movementVariant = (type) => (type === "IN" ? "success" : type === "OUT" ? "danger" : "warning");

export const signedQuantity = (movement) => (movement.type === "IN" ? `+${movement.quantity}` : movement.type === "OUT" ? `-${movement.quantity}` : `${movement.quantity}`);

export function MovementCard({ movement }) {
  const isIncoming = movement.type === "IN" || Number(movement.quantity) > 0;
  const badgeVariant = movementVariant(movement.type);
  const formattedDate = formatMovementTime(movement);

  return (
    <Card style={{ marginBottom: "0.65rem", padding: "0.85rem 1rem" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "0.5rem" }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: "600", fontSize: "0.95rem", color: "var(--text-main)" }}>
            {movement.itemName || "Unnamed Item"}
          </div>
          <div style={{ fontSize: "0.78rem", color: "var(--text-muted)", marginTop: "2px" }}>
            {movement.reason} {movement.itemSku && `• ${movement.itemSku}`}
          </div>
          {movement.notes && (
            <div style={{ fontSize: "0.75rem", color: "var(--text-dim)", marginTop: "3px", fontStyle: "italic" }}>
              "{movement.notes}"
            </div>
          )}
          <div style={{ fontSize: "0.72rem", color: "var(--text-dim)", marginTop: "4px" }}>
            🕒 {formattedDate}
          </div>
        </div>

        <div style={{ textAlign: "right", display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.25rem" }}>
          <Badge variant={badgeVariant}>
            {movement.type}
          </Badge>
          <div style={{
            fontSize: "1.05rem",
            fontWeight: "700",
            color: movement.type === "IN" ? "var(--success)" : (movement.type === "OUT" ? "var(--danger)" : "var(--warning)")
          }}>
            {signedQuantity(movement)}
          </div>
          <div style={{ fontSize: "0.72rem", color: "var(--text-dim)" }}>
            {movement.previousStock} ➔ {movement.newStock}
          </div>
        </div>
      </div>
    </Card>
  );
}

export default MovementCard;
